import type { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"

/** @titleBy title */
export interface Post {
    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Texto alternativo da imagem
     */
    alt?: string

    /**
     * @title Título
     */
    title: string

    /**
     * @title Descrição
     */
    description: string

    /**
     * @title Link
     */
    link: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string

    /**
     * @title Posts
     */
    posts: Post[]
}

export default function Blog({ title, posts }: Props) {
    if (!posts?.length) return null

    return (
        <div className='my-8'>
            <div className='p-3.5 bg-red-wine flex justify-center items-center lg:min-h-[240px] lg:pt-14 lg:items-start'>
                {title && (
                    <h2 className='text-white text-xl text-center uppercase font-medium lg:text-[25px]'>
                        {title}
                    </h2>
                )}
            </div>

            <div className='px-3.5 mt-6 grid gap-8 lg:max-w-[1220px] lg:-mt-28 lg:mx-auto md:grid-cols-3'>
                {posts.map((post) => (
                    <a href={post.link}>
                        <Image
                            className='w-full mb-4 mx-auto border-[3px] border-black rounded-[20px] object-cover aspect-[1/0.625]'
                            src={post.image}
                            alt={post.alt ?? title}
                            width={348}
                            height={234}
                            loading='lazy'
                        />

                        <strong className='mb-2 text-red-wine text-[17px] leading-5 block lg:text-inherit'>
                            {post.title}
                        </strong>

                        <p className='text-[17px] leading-5'>{post.description}</p>

                        <button className='mt-3.5 text-red-wine text-[17px] text-center font-extrabold'>
                            Saiba mais &gt;
                        </button>
                    </a>
                ))}
            </div>
        </div>
    )
}
